import { getCommerceApiContext } from '@dh-io-emh/commerce-api/src/common/commerce-api-context';
import { CommerceApiContextOptions } from '@dh-io-emh/commerce-api/src/common/types';
import { AppConfig, CommerceApiContext } from '@dh-io-emh/config-types';
import { getEngineDescription } from './utils/engine-description.util';
import { createHttpService } from './utils/http.util';
import { getTranslationFallback, getTranslationUnitFallback } from './utils/translation.utils';

export const getCommerceApiCommonOptions = (config: AppConfig): CommerceApiContextOptions => {
  const context: CommerceApiContext = getCommerceApiContext(config.apiMode, config.commerceApiContext);

  if (!config.focApiBaseUrl && context === CommerceApiContext.FOC) {
    throw new Error('No FOC api baseUrl provided');
  }

  const contextOptions: CommerceApiContextOptions = {
    context,
    httpServices: {
      product: {
        ocb: createHttpService({
          url: `${config.apiBaseUrl}/v2/${config.siteId}`,
          params: { lang: config.lang },
        }),
        foc: createHttpService({
          url: config.focApiBaseUrl!,
        }),
        bff: createHttpService({
          url: config.pdp.bffService.apiUrl.replace('{{siteId}}', config.siteId),
          params: { lang: config.lang },
        }),
      },
      search: {
        ocb: createHttpService({
          url: config.apiBaseUrl,
        }),
        foc: createHttpService({
          url: config.focApiBaseUrl!,
        }),
      },
      searchFilter: {
        ocb: createHttpService({
          url: config.apiBaseUrl,
        }),
        foc: createHttpService({
          url: config.focApiBaseUrl!,
        }),
      },
    },
  };

  return contextOptions;
};

export const getCommerceApiProductOptions = (config: AppConfig) => {
  const commonContextOptions = getCommerceApiCommonOptions(config);

  return {
    ...commonContextOptions,
    isBffEnabled: config.pdp.bffService.enabled,
    i18n: {
      lang: config.lang,
      getEngineDescription,
      getTranslationFallback,
      getTranslationUnitFallback,
    },
  };
};
